import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const MobileBottomNavbar = ({ user }) => {
	const { nonDigitalCategories } = useSelector((state) => state.landingPage)

	return (
		<div
			style={{
				paddingTop: '35px',
			}}
		>
			<div>
				<nav class='navbar bootom-bar fixed-bottom navbar-light bg-light display-mob '>
					<div class='container-fluid justify-content-center text-center'>
						<footer class='footer-wrap'>
							<div
								class='footer'
								style={{
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<div class='footer-item'>
									<Link to='/' class='footer-link mobile-bottom-background'>
										<img src='../../assets/img/salarnew.png' width='60' height='60' alt='' />
									</Link>
									<span className='text-dark text-xs'>
										<small>Home</small>
									</span>
								</div>

								<div class='footer-item'>
									<Link
										to={`/ProductListingCategories/${nonDigitalCategories[0]?._id}`}
										class='footer-link mobile-bottom-background'
									>
										<img src='../../assets/img/svg/Categories.svg' width='21' height='21' alt='' />
									</Link>
									<span className='text-dark text-xs'>
										<small>Category</small>
									</span>
								</div>
								<div class='footer-item'>
									<Link to='/' class='footer-link mobile-bottom-background'>
										<img src='../../assets/img/svg/Store.svg' width='21' height='21' alt='' />
									</Link>
									<span class='text-dark text-xs'>
										<small>Stores</small>
									</span>
								</div>
								{!user ? (
									<>
										<div class='footer-item'>
											<Link to='/UserSignUp' class='footer-link  mobile-bottom-background'>
												<img src='../../assets/img/svg/Signup.svg' width='21' height='21' alt='' />
											</Link>
											<span className='text-dark text-xs'>
												<small>Sign-Up</small>
											</span>
										</div>
										<div class='footer-item'>
											<Link to='/UserSignIn' class='footer-link mobile-bottom-background'>
												<img src='../../assets/img/svg/Signin.svg' width='21' height='21' alt='' />
											</Link>
											<span class='text-dark text-xs'>
												<small>Sign In</small>
											</span>
										</div>
									</>
								) : (
									''
								)}
								{user ? (
									<>
										<div class='footer-item'>
											<Link to='/user/dashboard'>
												<a class='footer-link mobile-bottom-background'>
													<img src='../../assets/img/svg/profile.svg' width='21' height='21' alt='' />
												</a>
												<span class='text-dark text-xs'>
													<small>My Profile</small>
												</span>
											</Link>
										</div>
										<div class='footer-item'>
											<Link to='/user/WithdrawlRequest'>
												<a class='footer-link mobile-bottom-background'>
													<img src='../../assets/img/svg/wallet.svg' width='21' height='21' alt='' />
												</a>
												<span class='text-dark text-xs'>
													<small>Withdrawal</small>
												</span>
											</Link>
										</div>
										<div class='footer-item'>
											<Link to='/user/ReferralComm'>
												<a class='footer-link mobile-bottom-background '>
													<img src='../../assets/img/svg/Signin.svg' width='21' height='21' alt='' />
												</a>
												<span class='text-dark text-xs'>
													<small>Earnings</small>
												</span>
											</Link>
										</div>
									</>
								) : (
									''
								)}
								{/* <div class='footer-item'>
									<a to='/' class='footer-link mobile-bottom-background'>
										<img src='../../assets/img/svg/wallet.svg' width='21' height='21' alt='' />
									</a>
									<span class='text-dark text-xs'>
										<small>Wallet</small>
									</span>
								</div>

								<div class='footer-item'>
									<a to='/' class='footer-link mobile-bottom-background'>
										<img src='../../assets/img/svg/Store.svg' width='21' height='21' alt='' />
									</a>
									<span class='text-dark text-xs'>
										<small>Withdrawal</small>
									</span>
								</div> */}
							</div>
						</footer>
					</div>
				</nav>
			</div>
		</div>
	)
}

export default MobileBottomNavbar
